export default `
uniform sampler2D uGitlines;
uniform sampler2D uShield;
uniform sampler2D uCircle;
uniform vec2 uResolution;
varying vec2 vUv;

void main(){
  vec4 shield = texture2D(uShield, (vUv - 0.5) * 1.0 + 0.5);
  vec4 gitlines = texture2D(uGitlines, vUv);

  vec4 maskImage = vec4(0.0);

  maskImage.rgb = gitlines.rgb;
  maskImage.a = mix(gitlines.a, 0.0, shield.a);

  maskImage.rgb = mix(vec3(1.0), maskImage.rgb, maskImage.a);

  float circle = texture2D(uCircle, vUv).r;
  vec4 color = maskImage;

  color.a *= circle;
  color.a += shield.a * 0.05;

  color.rgb += maskImage.rgb * (1.0 - color.a);

  color.rgb = mix(vec3(0.0), color.rgb, color.a);

  float gray = color.r + color.g + color.b;


  color.rgb = vec3(gray);
  color.a = 1.0;

  gl_FragColor = color;
}`
